import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';

const SpecialIntructionsTooltip = ({ className, t }) => (
  <div className={className}>
    <div className="tipWrapper">
      <div>
        <Icon glyph="specific-vehicle" size="2.4rem" />
      </div>
      <div>{t('additional_option_special_instruction_tooltip_1')}</div>
    </div>
    <div className="tipWrapper">
      <div>
        <Icon glyph="time" size="2.4rem" />
      </div>
      <div>{t('additional_option_special_instruction_tooltip_2')}</div>
    </div>
    <div className="tipWrapper">
      <div>
        <Icon glyph="document" size="2.4rem" />
      </div>
      <div>{t('additional_option_special_instruction_tooltip_3')}</div>
    </div>
    <div className="tipWrapper">
      <div>
        <Icon glyph="handling" size="2.4rem" />
      </div>
      <div>{t('additional_option_special_instruction_tooltip_4')}</div>
    </div>
    <div className="tipWrapper">
      <div className="iconlessInstruction">
        {t('additional_option_special_instruction_tooltip_5')
          ? t('additional_option_special_instruction_tooltip_5')
          : ''}
      </div>
    </div>
  </div>
);

SpecialIntructionsTooltip.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

SpecialIntructionsTooltip.defaultProps = {
  className: '',
  t: () => {},
};

export default SpecialIntructionsTooltip;
